import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import Header from "./header";
import Footer from "./footer";

export default function Wishlist() {
  const API_URL = "https://sunrise-backend.sunrisemeditechsystems.com/api"; // Corrected API_URL for direct image access
  const history = useHistory();
  const [wishlistItems, setWishlistItems] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [isInCart, setIsInCart] = useState(false); // New state
  const [products, setProducts] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [rentalStartDate, setRentalStartDate] = useState(new Date());
  const [rentalEndDate, setRentalEndDate] = useState(new Date());
  const [showOptions, setShowOptions] = useState(false); // New state to control visibility
  const [selectedAction, setSelectedAction] = useState(null); // 'cart' or 'wishlist'
  const [cartItemDetails, setCartItemDetails] = useState(null); // New state
  const product_id = localStorage.getItem("product_id");
  const isBuyOutOfStock = products.saleStock <= 0;
  const isRentOutOfStock = products.rentalStock <= 0;
  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${API_URL}/products`);
      setProducts(res.data);
    } catch (error) {
      console.error("Failed to fetch products:", error);
      setProducts([]);
    }
  };
  useEffect(() => {
    loadWishlistItems();
    fetchProducts();
  }, []);
  const loadWishlistItems = () => {
    const userId = localStorage.getItem("currentUserId");
    const wishlistKey = `wishlist_${userId}`;
    const storedWishlist = JSON.parse(
      localStorage.getItem(wishlistKey) || "[]"
    ).map((item) => ({
      ...item,
      quantity: item.quantity || 1,
      type: item.type || "buy",
    }));
    setWishlistItems(storedWishlist);
  };
  const handleRemoveFromWishlist = (productId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const userId = localStorage.getItem("currentUserId");
        const wishlistKey = `wishlist_${userId}`;
        const updatedWishlist = wishlistItems.filter(
          (item) => item.productId !== productId
        );
        localStorage.setItem(wishlistKey, JSON.stringify(updatedWishlist));
        setWishlistItems(updatedWishlist); // Update state to re-render
        Swal.fire(
          "Removed!",
          "Your product has been removed from wishlist.",
          "success"
        );
      }
    });
  };
  const handleAddToCart = (id) => {
    const product_details = products.find((product) => product.id === id);
    if (!product_details) return;
    if (selectedOption === "buy" && quantity > product_details.saleStock) {
      Swal.fire("Error", "Not enough stock available for purchase.", "error");
      return;
    }
    if (selectedOption === "rent" && product_details.rentalStock <= 0) {
      Swal.fire("Error", "Not enough stock available for rent.", "error");
      return;
    }

    const timeDiff = rentalEndDate.getTime() - rentalStartDate.getTime();
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    const rentalDays = diffDays > 0 ? diffDays : 1;

    const cartItem = {
      productId: product_details.id,
      name: product_details.name,
      price:
        selectedOption === "buy"
          ? product_details.salePrice
          : selectedOption === "rent"
          ? product_details.rentalPrice
          : product_details.salePrice,
      quantity: selectedOption === "buy" ? quantity : rentalDays,
      type: selectedOption,
      image: product_details.image,
    };

    if (selectedOption === "rent") {
      cartItem.rentalStartDate = rentalStartDate.toISOString();
      cartItem.rentalEndDate = rentalEndDate.toISOString();
    }

    // Get existing cart items from localStorage
    const userId = localStorage.getItem("currentUserId");
    const cartKey = `cart_${userId}`;
    const wishlistKey = `wishlist_${userId}`;
    let wishlist = JSON.parse(localStorage.getItem(wishlistKey) || "[]");

    // ✅ remove only this product id from wishlist
    wishlist = wishlist.filter((item) => item.productId !== cartItem.productId);
    localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
    const existingCart = JSON.parse(localStorage.getItem(cartKey) || "[]");

    // Check if item already exists in cart
    const existingItemIndex = existingCart.findIndex(
      (item) =>
        item.productId === cartItem.productId && item.type === cartItem.type
    );

    if (existingItemIndex > -1) {
      // Update quantity if item exists
      existingCart[existingItemIndex].quantity += cartItem.quantity;
    } else {
      // Add new item if it doesn't exist
      existingCart.push(cartItem);
    }

    // Save updated cart to localStorage
    const updatedCart = existingCart;
    localStorage.setItem(cartKey, JSON.stringify(updatedCart));
    window.dispatchEvent(new Event("cartUpdated")); // Dispatch event
    history.push("/cart");

    Swal.fire({
      title: "Success!",
      text: "Product added to cart",
      icon: "success",
      showConfirmButton: false,
      timer: 1500,
    });
    setShowOptions(false); // Hide options after adding to cart
    setQuantity(1); // Reset quantity
    setRentalStartDate(new Date());
    setRentalEndDate(new Date());
    setSelectedOption("buy"); // Reset option
    setSelectedAction(null); // Reset selected action
    setIsInCart(true); // Update cart status
    setCartItemDetails(cartItem); // Update cart item details
  };
  return (
    <>
      <div className="color-scheme-wrap active">
        <button className="switchIcon">
          <i className="fa-solid fa-palette"></i>
        </button>
        <h4 className="color-scheme-wrap-title">
          <i className="far fa-palette me-2"></i>Style Swicher
        </h4>
        <div className="color-switch-btns">
          <button data-color="#3E66F3">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#684DF4">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#008080">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#323F7C">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#FC3737">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#8a2be2">
            <i className="fa-solid fa-droplet"></i>
          </button>
        </div>
        <Link
          to="https://themeforest.net/user/themeholy"
          className="th-btn text-center w-100"
        >
          <i className="fa fa-shopping-cart me-2"></i> Purchase
        </Link>
      </div>
      {/* Preloader  */}
      {/* <div className="preloader ">
        <button className="th-btn preloaderCls">Cancel Preloader </button>
        <div className="preloader-inner">
            <img src="assets/img/logo.svg" alt="img"/>
            <div className="heart-rate">
                <img src="assets/img/shape/preloader.svg" alt=""/>

                <div className="fade-in"></div>

                <div className="fade-out"></div>
            </div>
        </div>
    </div> */}

      {/* Sidemenu */}
      <div className="sidemenu-wrapper shopping-cart">
        <div className="sidemenu-content">
          <button className="closeButton sideMenuCls">
            <i className="far fa-times"></i>
          </button>
          <div className="widget woocommerce widget_shopping_cart">
            <h3 className="widget_title">Shopping cart</h3>
            <div className="widget_shopping_cart_content">
              <ul className="woocommerce-mini-cart cart_list product_list_widget ">
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_1.jpg"
                      alt="Cart Image1"
                    />
                    Puregen Labs Meclizine
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $55.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_2.jpg"
                      alt="Cart Image2"
                    />
                    Pranarom Pure Essential Oil
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $15.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_3.jpg"
                      alt="Cart Image9"
                    />
                    Pediatric Stethoscope
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $30.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_4.jpg"
                      alt="Cart Image6"
                    />
                    Puregen Labs Allergy Relief
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $55.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_5.jpg"
                      alt="Cart Image8"
                    />
                    Digital Thermometer
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $15.99
                    </span>
                  </span>
                </li>
              </ul>
              <p className="woocommerce-mini-cart__total total">
                <strong>Subtotal:</strong>
                <span className="woocommerce-Price-amount amount">
                  <span className="woocommerce-Price-currencySymbol">$</span>
                  170.99
                </span>
              </p>
              <p className="woocommerce-mini-cart__buttons buttons btn-wrap">
                <Link to="cart.html" className="th-btn wc-forward">
                  View cart
                </Link>
                <Link to="checkout.html" className="th-btn checkout wc-forward">
                  Checkout
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Sidemenu */}
      <div className="sidemenu-wrapper ">
        <div className="sidemenu-content">
          <button className="closeButton sideMenuCls">
            <i className="far fa-times"></i>
          </button>
          <div className="widget footer-widget mb-0">
            <div className="th-widget-about">
              <div className="about-logo">
                <Link to="index.html">
                  <img src="assets/img/logo.svg" alt="Medova " />
                </Link>
              </div>
              <p className="about-text">
                Medova is a convenience services to the adaptability, Spacious
                modern villa living room with centrally placed swimming pool
                blending indooroutdoor
              </p>
            </div>
          </div>
          <div className="widget footer-widget">
            <h3 className="widget_title">Recent Posts</h3>
            <div className="recent-post-wrap">
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-1.jpg"
                      alt="Blog Image8"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>
                      April 02, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-2.jpg"
                      alt="Blog Image10"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>
                      April 25, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-3.jpg"
                      alt="Blog Image20"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>26
                      April, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-4.jpg"
                      alt="Blog Image21"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>27
                      April, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="widget footer-widget">
            <h3 className="widget_title">Social Media:</h3>
            <div className="th-social">
              <Link to="https://facebook.com">
                <i className="fab fa-facebook-f"></i>
              </Link>
              <Link to="https://twitter.com">
                <i className="fab fa-twitter"></i>
              </Link>
              <Link to="https://pinterest.com">
                <i className="fab fa-pinterest-p"></i>
              </Link>
              <Link to="https://linkedin.com">
                <i className="fab fa-linkedin-in"></i>
              </Link>
              <Link to="https://linkedin.com">
                <i className="fab fa-instagram"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="popup-search-box d-none d-lg-block">
        <button className="searchClose">
          <i className="fal fa-times"></i>
        </button>
        <form action="#">
          <input type="text" placeholder="What are you looking for?" />
          <button type="submit">
            <i className="fal fa-search"></i>
          </button>
        </form>
      </div>
      {/* Mobile Menu */}
      <div className="th-menu-wrapper">
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle">
            <i className="fal fa-times"></i>
          </button>
          <div className="mobile-logo">
            <Link to="/">
              <img src="assets/img/logo.svg" alt="Medova " />
            </Link>
          </div>

          <div className="th-mobile-menu">
            <ul>
              <li className="menu-item-has-children">
                <Link to="/">Home</Link>
                <ul className="sub-menu">
                  <li className="menu-item-has-children">
                    <Link to="#">Multipage</Link>
                    <ul>
                      <li>
                        <Link to="/">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care.html">Home Dental Care</Link>
                      </li>
                      <li>
                        <Link to="home-pediatric.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology.html">Home Cardiology</Link>
                      </li>
                      <li>
                        <Link to="home-surgery.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy.html">Home Physiotherapy</Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist.html">Home Optometrist</Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop.html">Home Medical Shop</Link>
                      </li>
                    </ul>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to="#">Onepage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic-op.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2-op.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care-op.html">Home Dental Care</Link>
                      </li>
                      <li>
                        <Link to="home-pediatric-op.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology-op.html">Home Cardiology</Link>
                      </li>
                      <li>
                        <Link to="home-surgery-op.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy-op.html">
                          Home Physiotherapy
                        </Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet-op.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist-op.html">Home Optometrist</Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop-op.html">
                          Home Medical Shop
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="about.html">About Us</Link>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Services</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="service.html">Services</Link>
                  </li>
                  <li>
                    <Link to="service-details.html">Service Details</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Pages</Link>
                <ul className="sub-menu">
                  <li className="menu-item-has-children">
                    <Link to="#">Shop</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="shop.html">Shop</Link>
                      </li>
                      <li>
                        <Link to="shop-details.html">Shop Details</Link>
                      </li>
                      <li>
                        <Link to="cart.html">Cart Page</Link>
                      </li>
                      <li>
                        <Link to="checkout.html">Checkout</Link>
                      </li>
                      <li>
                        <Link to="wishlist.html">Wishlist</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="doctor.html">Doctors</Link>
                  </li>
                  <li>
                    <Link to="doctor-details.html">Doctors Details</Link>
                  </li>
                  <li>
                    <Link to="case-studies.html">Case Studies</Link>
                  </li>
                  <li>
                    <Link to="case-studies-details.html">Case Studies Details</Link>
                  </li>
                  <li>
                    <Link to="appointment.html">Appointment</Link>
                  </li>
                  <li>
                    <Link to="pricing.html">Price Table</Link>
                  </li>
                  <li>
                    <Link to="error.html">Error Page</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Blog</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="#">Blog Layout</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="blog.html">Blog</Link>
                      </li>
                      <li>
                        <Link to="blog-grid.html">Blog Grid</Link>
                      </li>
                      <li>
                        <Link to="blog-grid-sidebar.html">
                          Blog Grid With Sidebar
                        </Link>
                      </li>
                      <li>
                        <Link to="blog-list.html">Blog List</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="blog-details.html">Blog Details</Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Header Area */}
      <Header />
      {/* Breadcumb */}
      <div
        className="breadcumb-wrapper "
        data-bg-src="assets/img/bg/breadcumb-bg.jpg"
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Wishlist</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Wishlist</li>
            </ul>
          </div>
        </div>
      </div>
      {/* Checkout Area */}
      <div className="space">
        <div className="container">
          <div className="tinv-wishlist woocommerce tinv-wishlist-clear">
            <div className="tinv-header">
              <h2 className="mb-30">Wishlist</h2>
            </div>
            <form autoComplete="off">
              <table className="tinvwl-table-manage-list">
                <thead>
                  <tr>
                    <th className="product-cb">
                      <input
                        type="checkbox"
                        className="global-cb"
                        title="Select all for bulk action"
                      />
                    </th>
                    <th className="product-remove"></th>
                    <th className="product-thumbnail">&nbsp;</th>
                    <th className="product-name">
                      <span className="tinvwl-full">Product Name</span>
                      <span className="tinvwl-mobile">Product</span>
                    </th>
                    <th className="product-price">Unit Price</th>
                    <th className="product-date">Date Added</th>
                    <th className="product-stock">Stock Status</th>
                    <th className="product-action">&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {wishlistItems.length === 0 ? (
                    <tr>
                      <td
                        colSpan="7"
                        className="text-center"
                        style={{ verticalAlign: "middle", padding: "15px 5px" }}
                      >
                        Your wishlist is empty.
                      </td>
                    </tr>
                  ) : (
                    <>
                      {wishlistItems.map((item) => (
                        <tr key={item.productId} className="wishlist_item">
                          {/* <td className="product-cb">
                            <input
                              type="checkbox"
                              name="wishlist_pr[]"
                              value="58"
                              title="Select for bulk action"
                            />
                          </td> */}
                          <td className="product-remove">
                            {/* <button type="submit" name="tinvwl-remove" value="58" title="Remove"><i className="fal fa-times"></i>
                                    </button> */}
                            <button
                              onClick={(e) =>
                              {e.preventDefault();handleRemoveFromWishlist(item.productId)}
                              }
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                color: "red",
                                fontSize: "1.2em",
                              }}
                            >
                              <i className="fa fa-times"></i>
                            </button>
                          </td>
                          <td className="product-thumbnail">                           
                            <Link to={`/product/${item.productId}`}>
                              <img
                                src={`https://sunrise-backend.sunrisemeditechsystems.com${item.image}`}
                                alt={item.name}
                                style={{ width: "80px", height: "auto" }}
                              />
                            </Link>
                          </td>
                          <td className="product-name">                            
                            <Link to={`/product/${item.productId}`}>
                              {item.name}
                            </Link>
                          </td>
                          <td className="product-price">
                            <span className="woocommerce-Price-amount amount">
                              <bdi>
                                <span className="woocommerce-Price-currencySymbol">
                                  $
                                </span>
                                ₹{item.price.toFixed(2)}
                              </bdi>
                            </span>
                          </td>
                          <td className="product-date">
                            <time
                              className="entry-date"
                              dateTime="2021-11-21 03:54:24"
                            >
                              November 21, 2021
                            </time>
                          </td>
                          <td className="product-stock">
                            <p className="stock in-stock">
                              <span>
                                <i className="fas fa-check"></i>
                              </span>
                              <span className="tinvwl-txt">In stock</span>
                            </p>
                          </td>
                          <td className="product-action">
                            <button
                              className="button th-btn"
                              name="tinvwl-add-to-cart"
                              value="58"
                              title="Add to Cart"
                              onClick={(e) => {
                                e.preventDefault();
                                if (isBuyOutOfStock && selectedOption === "buy")
                                  return;
                                if (
                                  isRentOutOfStock &&
                                  selectedOption === "rent"
                                )
                                  return;
                                isInCart
                                  ? history.push("/cart")
                                  : handleAddToCart(item.productId);
                              }}
                            >
                              <i className="fal fa-shopping-cart"></i>
                              <span className="tinvwl-txt">Add to Cart</span>
                            </button>
                          </td>
                        </tr>
                      ))}
                      {/* <tr className="wishlist_item">
                                <td className="product-cb">
                                    <input type="checkbox" name="wishlist_pr[]" value="60" title="Select for bulk action"/>
                                </td>
                                <td className="product-remove">
                                    <button type="submit" name="tinvwl-remove" value="60" title="Remove"><i className="fal fa-times"></i>
                                    </button>
                                </td>
                                <td className="product-thumbnail">
                                    <Link to="shop-details.html"><img src="assets/img/product/product_thumb_1_2.jpg" className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" alt="image"/></Link>
                                </td>
                                <td className="product-name">
                                    <Link to="shop-details.html">Smartphone Vivo V9</Link>
                                </td>
                                <td className="product-price">
                                    <ins><span className="woocommerce-Price-amount amount"><bdi><span className="woocommerce-Price-currencySymbol">$</span>18.00</bdi></span></ins>
                                    <del><span className="woocommerce-Price-amount amount"><bdi><span className="woocommerce-Price-currencySymbol">$</span>20.00</bdi></span></del>
                                </td>
                                <td className="product-date">
                                    <time className="entry-date" dateTime="2021-11-21 03:54:24">November 21, 2021</time>
                                </td>
                                <td className="product-stock">
                                    <p className="stock in-stock"><span><i className="fas fa-check"></i></span><span className="tinvwl-txt">In stock</span></p>
                                </td>
                                <td className="product-action">
                                    <button className="button th-btn" name="tinvwl-add-to-cart" value="60" title="Add to Cart">
                                        <i className="fal fa-shopping-cart"></i><span className="tinvwl-txt">Add to Cart</span>
                                    </button>
                                </td>
                            </tr>
                            <tr className="wishlist_item">
                                <td className="product-cb">
                                    <input type="checkbox" name="wishlist_pr[]" value="60" title="Select for bulk action"/>
                                </td>
                                <td className="product-remove">
                                    <button type="submit" name="tinvwl-remove" value="60" title="Remove"><i className="fal fa-times"></i>
                                    </button>
                                </td>
                                <td className="product-thumbnail">
                                    <Link to="shop-details.html"><img src="assets/img/product/product_thumb_1_3.jpg" className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" alt="image"/></Link>
                                </td>
                                <td className="product-name">
                                    <Link to="shop-details.html">SanDisk Flash Drive</Link>
                                </td>
                                <td className="product-price">
                                    <ins><span className="woocommerce-Price-amount amount"><bdi><span className="woocommerce-Price-currencySymbol">$</span>18.00</bdi></span></ins>
                                    <del><span className="woocommerce-Price-amount amount"><bdi><span className="woocommerce-Price-currencySymbol">$</span>20.00</bdi></span></del>
                                </td>
                                <td className="product-date">
                                    <time className="entry-date" dateTime="2021-11-21 03:54:24">November 21, 2021</time>
                                </td>
                                <td className="product-stock">
                                    <p className="stock in-stock"><span><i className="fas fa-check"></i></span><span className="tinvwl-txt">In stock</span></p>
                                </td>
                                <td className="product-action">
                                    <button className="button th-btn" name="tinvwl-add-to-cart" value="60" title="Add to Cart">
                                        <i className="fal fa-shopping-cart"></i><span className="tinvwl-txt">Add to Cart</span>
                                    </button>
                                </td>
                            </tr> */}
                    </>
                  )}
                </tbody>
              </table>
            </form>
            <div className="social-buttons">
              <span>Share on</span>
              <ul>
                <li>
                  <Link
                    to="https://www.facebook.com/sharer/sharer.php?u=permalink"
                    className="social social-facebook"
                    title="Facebook"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://twitter.com/share?url=permalink"
                    className="social social-twitter "
                    title="Twitter"
                  >
                    <i className="fab fa-twitter"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="http://pinterest.com/pin/create/button/?url=permalink"
                    className="social social-pinterest "
                    title="Pinterest"
                  >
                    <i className="fab fa-pinterest-p"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://api.whatsapp.com/send?text=permalink"
                    className="social social-whatsapp "
                    title="WhatsApp"
                  >
                    <i className="fab fa-whatsapp"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="http://vecurosoft.com/products/wordpress/foodelio/wishlist/974b61/"
                    className="social social-clipboard "
                    title="Clipboard"
                  >
                    <i className="far fa-clipboard"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="mailto:?body=permalink"
                    className="social social-email "
                    title="Email"
                  >
                    <i className="far fa-envelope"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* Footer Area */}
      <Footer />
    </>
  );
}
